import { Entity } from "src/app/core/utils/entity";

export abstract class DeleteCompanyEntity extends Entity {
    constructor(
        public id: string
    ) {
        super();
    }
}